import React, { FC } from 'react';
import styled from 'styled-components';
import { TextArea } from 'components/atoms/input';
import { PLACEHOLDER } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/constant';
import { MultiLineTextField as MultiLineTextFieldT } from 'components/organisms/tasks/fields';
import { useInput } from 'hooks/use-input';

const TextAreaStyled = styled(TextArea)`
  padding: var(--spacing-02) var(--spacing-05);
`;

interface FieldProps {
  field: MultiLineTextFieldT;
  onChange?: (selected: string, field: MultiLineTextFieldT) => void;
}

export const MultiLineTextField: FC<FieldProps> = ({ field, onChange }) => {
  const { value = '' } = field;
  const [state, onInputChange, setState] = useInput(value || '');

  const commit = (latest: string) => {
    setState(latest);
    if (value !== latest) {
      if (onChange) {
        onChange(latest, field);
      }
    }
  };

  return (
    <TextAreaStyled
      value={state}
      placeholder={PLACEHOLDER}
      onChange={onInputChange}
      onBlur={(e) => commit(e.currentTarget.value)}
      data-cy={`right.content.${field.fieldLabel}`}
      autoSize={{
        minRows: 1,
        maxRows: 2,
      }}
    />
  );
};
